import { CreateGameRequest, CreateGameResponse } from '../shared/functionTypes';
import useFirebaseFunctionAsync from './useFirebaseFunctionAsync';

const useCreateGameAsync = () =>
  useFirebaseFunctionAsync<CreateGameRequest, CreateGameResponse>('createGame');

export default useCreateGameAsync;
